import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface DepositSettings {
  depositEnabled: boolean;
  depositAmount: number;
  depositType: "fixed" | "percentage";
  loading: boolean;
}

export const useDepositSettings = (): DepositSettings => {
  const [depositEnabled, setDepositEnabled] = useState(true);
  const [depositAmount, setDepositAmount] = useState(0);
  const [depositType, setDepositType] = useState<"fixed" | "percentage">("fixed");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      const { data } = await supabase
        .from("site_settings")
        .select("key, value")
        .in("key", ["deposit_enabled", "deposit_amount", "deposit_type"]);
      if (data) {
        const get = (k: string) => data.find((r: any) => r.key === k)?.value;
        const enabled = get("deposit_enabled");
        setDepositEnabled(enabled !== "false");
        const amt = get("deposit_amount");
        setDepositAmount(amt !== undefined && amt !== null ? Number(amt) : 0);
        setDepositType(get("deposit_type") === "percentage" ? "percentage" : "fixed");
      }
      setLoading(false);
    };
    fetch();
  }, []);

  return { depositEnabled, depositAmount, depositType, loading };
};
